import React from 'react'
import styles from '../Hero.css'
import PropTypes from "prop-types"
import ScrollPercentage from 'react-scroll-percentage'

const BackgroundImageParallax = ({ imageSrc, disabled }) => {

  return (
    <div 
      className={imageSrc ? styles.backgroundImageContainer : ''}
      style={{ opacity: (imageSrc ? 1 : 0) }}
    >
      {imageSrc &&
        <ScrollPercentage className={styles.scrollPercentage}>
          {({percentage}) => (
            <div
              className={styles.backgroundImage}
              style={{
                backgroundImage: `url(${imageSrc})`,
                ...(disabled
                  ? {} 
                  : { transform: `translateY(${(-.5 + (percentage === 1 ? .5 : percentage)) * 20}%)`}
                )
              }}
            />
          )}
        </ScrollPercentage>
      }
    </div>
  )
}

BackgroundImageParallax.propTypes = {
  imageSrc: PropTypes.string,
  disabled: PropTypes.bool
}

BackgroundImageParallax.defaultProps = {
  disabled: false 
}

export default BackgroundImageParallax



// WEBPACK FOOTER //
// ./src/components/Hero/partials/BackgroundImageParallax.js